import apiClient, { getCsrfCookie } from './client';
import type { OnboardingStatus } from '../types/onboarding';

const ONBOARDING_BASE = '/api/admin/onboarding';

export const onboardingApi = {
  async getStatus(): Promise<OnboardingStatus> {
    const response = await apiClient.get<{ data: OnboardingStatus }>(`${ONBOARDING_BASE}/status`);
    return response.data.data;
  },

  async completeStep(step: string): Promise<OnboardingStatus> {
    await getCsrfCookie();
    const response = await apiClient.post<{ data: OnboardingStatus }>(
      `${ONBOARDING_BASE}/complete-step`,
      { step }
    );
    return response.data.data;
  },

  async complete(): Promise<OnboardingStatus> {
    await getCsrfCookie();
    const response = await apiClient.post<{ data: OnboardingStatus }>(
      `${ONBOARDING_BASE}/complete`
    );
    return response.data.data;
  },
};
